import { useMemo } from 'react';
import type { CalEvent } from '@aop/domain';
import { toCamel } from '../../lib/case';
import { useRows } from '../../lib/data';

export function normEvent(r: Record<string, unknown>): CalEvent {
  const c = toCamel<Record<string, unknown>>(r);
  return {
    id: String(c.id), title: String(c.title ?? ''), type: String(c.type ?? 'meet'), date: String(c.date ?? ''), endDate: String(c.endDate ?? ''), allDay: !!c.allDay,
    start: String(c.startTime ?? ''), end: String(c.endTime ?? ''), location: String(c.location ?? ''), note: String(c.note ?? ''), attendeeIds: (c.attendeeIds as string[]) ?? [],
    public: !!c.isPublic, taskId: String(c.taskId ?? ''), createdById: String(c.createdBy ?? ''), createdBy: String(c.createdByName ?? ''), createdAt: String(c.createdAt ?? ''),
  };
}

export function useEvents() {
  const q = useRows<Record<string, unknown>>('events', { order: 'date' });
  const data = useMemo(() => q.data?.map(normEvent), [q.data]);
  return { ...q, data };
}

/** Cột CSDL từ dữ liệu sự kiện trong form. */
export function eventRow(d: { title: string; type: string; date: string; endDate: string; allDay: boolean; start: string; end: string; location: string; note: string; attendeeIds: string[]; public: boolean; taskId: string }) {
  return {
    title: d.title, type: d.type, date: d.date, end_date: d.endDate || null, all_day: d.allDay, start_time: d.start, end_time: d.end, location: d.location, note: d.note,
    attendee_ids: d.attendeeIds, is_public: d.public, task_id: d.taskId || null,
  };
}
